/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DocsTextIcon16Light } from './DocsTextIcon16Light';
import { DocsTextIcon16Regular } from './DocsTextIcon16Regular';
import { DocsTextIcon16Solid } from './DocsTextIcon16Solid';
import { DocsTextIcon20Light } from './DocsTextIcon20Light';
import { DocsTextIcon20Regular } from './DocsTextIcon20Regular';
import { DocsTextIcon20Solid } from './DocsTextIcon20Solid';
import { DocsTextIcon24Regular } from './DocsTextIcon24Regular';
import { DocsTextIcon24Solid } from './DocsTextIcon24Solid';
import { DocsTextIcon32Regular } from './DocsTextIcon32Regular';
import { DocsTextIcon64Regular } from './DocsTextIcon64Regular';
var sizes = {
    16: {
        light: DocsTextIcon16Light,
        regular: DocsTextIcon16Regular,
        solid: DocsTextIcon16Solid,
    },
    20: {
        light: DocsTextIcon20Light,
        regular: DocsTextIcon20Regular,
        solid: DocsTextIcon20Solid,
    },
    24: {
        regular: DocsTextIcon24Regular,
        solid: DocsTextIcon24Solid,
    },
    32: {
        regular: DocsTextIcon32Regular,
    },
    64: {
        regular: DocsTextIcon64Regular,
    },
};
export var DocsTextIcon = forwardRef('DocsTextIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
